import HttpRequest from "@/plugins/http";

const request = new HttpRequest({
  // baseURL: "/roomit/platform/dev/v1",
  baseURL: "https://air.mycwt.com.cn/profileservice/api/v1",
});

const axios = request.request();


/**
 * User getOperator
 * @export
 * @returns
 */
export async function getOperator() {
  return axios.get("/user/getOperator");
}


/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function addLoyaltyCard(params) {
  return axios.post("/UserHotelCard/Add", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function editLoyaltyCard(params) {
  return axios.post("/UserHotelCard/Update", params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function getCreditCard(params) {
  return axios.get("/UserCreditCard/ListEncrypt/" + params);
}

/**
 * @export
 * @param {JSON} params - 查看swagger
 * @returns
 */
export async function addUserCreditCard(params) {
  return axios.post("/UserCreditCard/Add", params);
}

